import { createClient } from '@supabase/supabase-js'

// NOTE: These must be accessed as static `process.env.NEXT_PUBLIC_*` member
// expressions (not via requireEnv's dynamic `process.env[name]` lookup) so that
// Next.js/Turbopack inlines the values into the browser bundle. This module is
// imported by client components, so a dynamic lookup would resolve to undefined
// on the client and throw "Missing required environment variable".
const storageUrl = process.env.NEXT_PUBLIC_SUPABASE_STORAGE_URL
const storageAnonKey = process.env.NEXT_PUBLIC_SUPABASE_STORAGE_ANON_KEY

if (!storageUrl || !storageAnonKey) {
  throw new Error(
    'Missing required environment variable: NEXT_PUBLIC_SUPABASE_STORAGE_URL / NEXT_PUBLIC_SUPABASE_STORAGE_ANON_KEY'
  )
}

export const storageClient = createClient(storageUrl, storageAnonKey)

/* `handleImageUpload` was removed here.

   It duplicated StorageService.uploadImage in lib/storage.ts — same validate,
   same normalize, same resize, same upload — and nothing called it; the only
   importer (lib/actions.ts) never invoked it. Two entry points for the same
   job is how upload rules drift apart. Client uploads go through
   `storage.uploadImage`, server uploads through `uploadBuffer`. */
